// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__rcH3p","loader":"Loader_loader__zr58s","load5":"Loader_load5__MTH3C","text":"Loader_text__Cx43S"};